import { pad2 } from "../../lib/domain.js";

/* This playground's process, as ordered stages. The PRD calls playgrounds
   1–8 "fully specced" but carries no stage content, so every flow starts
   empty and each team fills in its own. */
export function FlowEditor({ flow, onChange }) {
  if (!flow.length) {
    return (
      <p className="empty">
        No stages yet. Add the first step of this playground’s process.
      </p>
    );
  }

  const move = (i, delta) => {
    const next = flow.slice();
    const j = i + delta;
    if (j < 0 || j >= next.length) return;
    [next[i], next[j]] = [next[j], next[i]];
    onChange(next);
  };

  const set = (i, field, value) => {
    const next = flow.slice();
    next[i] = { ...next[i], [field]: value };
    onChange(next);
  };

  return (
    <div className="flow">
      {flow.map((s, i) => (
        <article className="stage" key={i}>
          <div className="top">
            <span className="no">STEP {pad2(i + 1)}</span>
            <button
              className="btn-icon"
              type="button"
              aria-label="Move earlier"
              disabled={i === 0}
              onClick={() => move(i, -1)}
            >
              &#8592;
            </button>
            <button
              className="btn-icon"
              type="button"
              aria-label="Move later"
              disabled={i === flow.length - 1}
              onClick={() => move(i, 1)}
            >
              &#8594;
            </button>
            <button
              className="btn-icon"
              type="button"
              aria-label="Delete stage"
              onClick={() => onChange(flow.filter((_, j) => j !== i))}
            >
              &#10005;
            </button>
          </div>
          <input
            className="in"
            value={s.title}
            placeholder="Stage"
            aria-label={"Stage " + (i + 1) + " name"}
            onChange={(e) => set(i, "title", e.target.value)}
          />
          <textarea
            className="in"
            value={s.description}
            placeholder="What happens here"
            aria-label={"Stage " + (i + 1) + " detail"}
            onChange={(e) => set(i, "description", e.target.value)}
          />
        </article>
      ))}
    </div>
  );
}
